module.exports = __webpack_public_path__ + "static/img/yingxiao_icon1.4bc8fe9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/broadcast/yingxiao_icon1.png
// module id = qMHU
// module chunks = 0